/* eslint-disable @typescript-eslint/no-unused-vars */
// import { useUsers } from "@/contexts/users.context";
// import { ActionConst } from "@/reducers/users.reducer";
import axios, { AxiosError, AxiosResponse } from "axios";

const useRequest = (baseURL: string = process.env.API_BASE_URL!) => {
    // console.log("🚀 ~ file: request.hook.ts:10 ~ useRequest ~ user:", user);
    // const { dispatch, isLoggedIn, access_token } = useUsers();

    const instance = axios.create({ baseURL, withCredentials: true });

    // Axios request interceptor.
    instance.interceptors.request.use(
        (request) => request,
        (error) => Promise.reject(error),
    );

    // Axios response interceptor.
    // Keep it defensive: `error.response` is undefined for network/timeout/CORS
    // failures, so destructuring it blindly would throw a secondary TypeError and
    // mask the original error. Simply forward the rejection to the caller instead.
    instance.interceptors.response.use(
        (response) => response,
        (error) => Promise.reject(error),
    );

    // const request = ({ ...options }) => {
    //     const onSuccess = (res: AxiosResponse) => res.data;
    //     const onError = (err: AxiosError) => err.response;
    //     try {
    //         return instance(options);
    //     } catch (err: any) {
    //         const { response } = err as AxiosError;
    //         return { error: response?.data };
    //     }
    // };

    // const request = ({ ...options }) => {
    //     const onSuccess = (res: AxiosResponse) => res.data;
    //     const onError = (err: AxiosError) => err.response;
    //     return instance(options).then(onSuccess).catch(onError);
    // };

    // This fn is mostly used in useSWR.
    const fetcher = ({ ...options }) => {
        return instance(options).then((res) => res.data);
    };

    return { request: instance, fetcher };
};

export default useRequest;
